<template>
  <div class="company-invite-setting" v-loading="loading">
    <div class="title">
      <div class="close" @click="goToReview">
        <span class="pointer">
          邀请审核 /
          <span style="color: #606266">邀请设置</span>
        </span>
      </div>
    </div>
    <div class="setting" v-for="(setting, index) in settings" :key="index">
      <el-row>
        <el-col :span="20">
          <div class="item">{{ setting.label }}</div>
          <div style="font-size: 14px; color:#9e9e9e">{{ setting.detail }}</div>
          <div style="font-size: 14px;" v-if="setting.value === 'search'">
            企业编号：{{ currentCompany.code }}
            <el-button type="text" @click="copyCompanyCode">复制</el-button>
          </div>
        </el-col>
        <el-col :span="4">
          <div v-if="setting.value === 'search'" style="float: right; margin-top: 24px;">
            <el-switch
              v-model="userJoinEnable"
              @change="setCompanyInfo('userJoinEnable')"
            ></el-switch>
            <span style="margin-left: 6px; font-size: 14px">
              {{ userJoinEnable ? "开启" : "关闭" }}
            </span>
          </div>
          <div v-else style="float: right;margin-top: 15px;">
            <el-switch
              v-model="userJoinNeedVerify"
              @change="setCompanyInfo('userJoinNeedVerify')"
            ></el-switch>
            <span style="margin-left: 6px; font-size: 14px">
              {{ userJoinNeedVerify ? "开启" : "关闭" }}
            </span>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
    </div>
  </div>
</template>
<script>
import { getCurCompany } from "@/api/userCenter/company"
import { setCompanyState } from "@/api/user"
import { copyToClipBoard } from "@/utils/common"
export default {
  name: "company-invite-setting",
  data() {
    return {
      settings: [
        {
          label: "搜索企业加入",
          value: "search",
          detail: "开启后，成员可通过搜索企业编号加入企业"
        },
        {
          label: "成员审核加入",
          value: "review",
          detail: "开启后，成员需通过审批才能加入；关闭后，成员无需审批即可加入"
        }
      ],
      loading: false,
      transferVisible: false,
      transferForm: {},
      dismissVisible: false,
      companyName: "",
      currentCompany: {},
      userJoinEnable: false,
      userJoinNeedVerify: false
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo || {}
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      getCurCompany().then(currentCompany => {
        this.currentCompany = currentCompany
        this.userJoinEnable = this.currentCompany.userJoinEnable
        this.userJoinNeedVerify = this.currentCompany.userJoinNeedVerify
        this.loading = false
      })
    },
    goToReview() {
      this.$router.push({ name: "company-review" })
    },
    setCompanyInfo(from) {
      let params = {
        companyId: this.currentCompany.id,
        userJoinEnable: from === "userJoinEnable" ? this.userJoinEnable : null,
        userJoinNeedVerify: from === "userJoinNeedVerify" ? this.userJoinNeedVerify : null
      }
      setCompanyState(params)
    },
    copyCompanyCode() {
      copyToClipBoard(this.currentCompany.code)
    }
  }
}
</script>
<style lang="scss" scoped>
.company-invite-setting {
  .title {
    font-size: $font-size-title-first;
    padding: 0 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
    .close {
      display: flex;
      align-items: center;
      color: #84878c;
    }
  }
  .setting {
    width: 90%;
    margin: 30px 50px;
    .el-row {
      padding-left: 10px;
      padding-right: 60px;
    }
    .item {
      margin-bottom: 5px;
      font-weight: bold;
    }
  }
}
</style>
